/* OTUNBA — product page LV-style description Read more
   Converts the existing .product-description-dropdown (which has its own button+JS toggle
   on alt-template products) into a clamped 3-line preview with a Read more / Read less toggle. */
(function () {
  function init() {
    document.querySelectorAll('.product-description-dropdown').forEach(function (dd) {
      if (dd.dataset.otunbaConverted) return;
      dd.dataset.otunbaConverted = '1';

      var content = dd.querySelector('.dropdown-content');
      var oldBtn = dd.querySelector('.dropdown-button');
      if (!content) return;

      // Drop the original button + any inline display: none on content
      if (oldBtn) oldBtn.remove();
      content.style.removeProperty('display');
      content.classList.add('product__description--clamped');

      // Insert read-more toggle
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'product__description-readmore';
      btn.textContent = 'Read more';
      btn.setAttribute('aria-expanded', 'false');

      btn.addEventListener('click', function () {
        var expanded = content.classList.toggle('product__description--expanded');
        btn.textContent = expanded ? 'Read less' : 'Read more';
        btn.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      });

      dd.appendChild(btn);
    });
  }

  function initSidePanel() {
    var panel = document.getElementById('OtunbaSizeGuide');
    if (!panel) return;
    var triggers = document.querySelectorAll('[data-size-guide-open]');
    var closers = panel.querySelectorAll('[data-side-panel-close]');

    function activateTab(target) {
      if (!target) return;
      var tabs = panel.querySelectorAll('.size-guide__tab');
      var matched = false;
      tabs.forEach(function (t) {
        var v = (t.getAttribute('data-size-tab') || '').toLowerCase();
        // Tolerate variants: data-size-tab="men", "mens", "women", "womens".
        var hit = v === target || v === target.replace(/s$/, '') || (v + 's') === target;
        t.classList.toggle('is-active', hit);
        t.setAttribute('aria-selected', hit ? 'true' : 'false');
        if (hit) matched = true;
      });
      panel.querySelectorAll('.size-guide__panel').forEach(function (p) {
        var v = (p.getAttribute('data-size-panel') || '').toLowerCase();
        var hit = v === target || v === target.replace(/s$/, '') || (v + 's') === target;
        p.classList.toggle('is-active', hit);
      });
      return matched;
    }

    function open(e) {
      panel.setAttribute('aria-hidden', 'false');
      document.body.classList.add('otunba-side-panel-open');
      // If the trigger declared a product gender, activate the matching tab.
      var btn = e && e.currentTarget;
      var gender = btn && btn.getAttribute('data-product-gender');
      if (gender) activateTab(gender.toLowerCase());
    }
    function close() {
      panel.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('otunba-side-panel-open');
    }

    triggers.forEach(function (t) { t.addEventListener('click', open); });
    closers.forEach(function (c) { c.addEventListener('click', close); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && panel.getAttribute('aria-hidden') === 'false') close();
    });
  }

  function initSizeGuideTabs() {
    var tabs = document.querySelectorAll('.size-guide__tab');
    if (!tabs.length) return;
    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var target = tab.getAttribute('data-size-tab');
        document.querySelectorAll('.size-guide__tab').forEach(function (t) {
          var active = t.getAttribute('data-size-tab') === target;
          t.classList.toggle('is-active', active);
          t.setAttribute('aria-selected', active ? 'true' : 'false');
        });
        document.querySelectorAll('.size-guide__panel').forEach(function (p) {
          p.classList.toggle('is-active', p.getAttribute('data-size-panel') === target);
        });
      });
    });
  }

  /* Hover-scroll: scrolling over the gallery (left) scrolls images; scrolling over the info column (right)
     scrolls page or info content. No click needed. */
  function initHoverScroll() {
    if (window.matchMedia('(max-width: 989px)').matches) return; // desktop only
    var gallery = document.querySelector('body.template-product .product__media-wrapper');
    var infoWrap = document.querySelector('body.template-product .product__info-wrapper');

    function attach(el, scrollPageWhenExhausted) {
      if (!el || el.dataset.otunbaHover) return;
      el.dataset.otunbaHover = '1';
      el.addEventListener('wheel', function (e) {
        var dy = e.deltaY;
        if (!dy) return;
        var atTop = el.scrollTop <= 0;
        var atBottom = el.scrollTop + el.clientHeight >= el.scrollHeight - 1;
        // If we'd scroll past the edge AND should cascade to page, let the default happen (don't preventDefault)
        if ((dy < 0 && atTop) || (dy > 0 && atBottom)) {
          if (scrollPageWhenExhausted) return; // let page scroll
        }
        // Otherwise scroll the element ourselves and stop it from also scrolling the page
        el.scrollTop += dy;
        e.preventDefault();
      }, { passive: false });
    }

    attach(gallery, true);  // gallery: scroll internally, cascade to page when exhausted
    // Info column: when content fits in 100vh, just let page scroll (no internal scroll needed)
    if (infoWrap && infoWrap.scrollHeight > infoWrap.clientHeight + 1) {
      attach(infoWrap, true);
    }

    /* Hide the header when the gallery starts scrolling — photos take full viewport */
    if (gallery) {
      gallery.addEventListener('scroll', function () {
        var scrolled = gallery.scrollTop > 8;
        document.body.classList.toggle('otunba-product-gallery-scrolled', scrolled);
      }, { passive: true });
    }
  }

  /* Sticky Add-to-Bag bar — slides in from top when the real CTA scrolls out of view */
  function initStickyCta() {
    var sticky = document.getElementById('OtunbaStickyCta');
    var realCta = document.querySelector('.product-form__submit');
    if (!sticky || !realCta) return;

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          // Show sticky when the real CTA is NOT in view AND we've scrolled past it
          var pastIt = e.boundingClientRect.top < 0;
          if (!e.isIntersecting && pastIt) {
            sticky.classList.add('is-visible');
            sticky.setAttribute('aria-hidden', 'false');
          } else {
            sticky.classList.remove('is-visible');
            sticky.setAttribute('aria-hidden', 'true');
          }
        });
      }, { rootMargin: '-1px 0px 0px 0px', threshold: 0 });
      io.observe(realCta);
    }

    // Wire sticky button to trigger the real form submit (real form does the actual work)
    var stickyBtn = sticky.querySelector('[data-otunba-sticky-buy]');
    if (stickyBtn) {
      stickyBtn.addEventListener('click', function () {
        // Scroll the real form into view so user can pick variants if needed, then click it
        var form = realCta.closest('product-form, form');
        if (form) {
          // If a variant isn't selected, scroll back to picker so user can choose
          var hasVariant = !!realCta.disabled === false;
          if (realCta.disabled) {
            form.scrollIntoView({ behavior: 'smooth', block: 'center' });
            return;
          }
        }
        realCta.click();
      });
    }
  }

  /* BUY NOW — fetch /cart/add.js with current form data, then redirect to /checkout.
     Replaces the Shopify dynamic-checkout "Buy with Shop" button. */
  function initBuyNow() {
    document.querySelectorAll('[data-buy-now]').forEach(function (btn) {
      btn.addEventListener('click', async function (e) {
        e.preventDefault();
        if (btn.hasAttribute('disabled')) return;
        var form = btn.closest('form');
        if (!form) return;
        var orig = btn.textContent;
        btn.textContent = 'Adding…';
        btn.setAttribute('disabled', 'disabled');
        try {
          var fd = new FormData(form);
          // Don't send the buy-now button as a form field.
          fd.delete('checkout');
          var res = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Accept': 'application/javascript' },
            body: fd
          });
          if (!res.ok) {
            var msg = await res.json().catch(function () { return null; });
            throw new Error(msg && msg.description || ('add failed ' + res.status));
          }
          window.location.href = '/checkout';
        } catch (err) {
          btn.textContent = orig;
          btn.removeAttribute('disabled');
          // Show the form's error message wrapper if present.
          var errBox = form.closest('product-form, .product-form');
          if (errBox) {
            var msgEl = errBox.querySelector('.product-form__error-message');
            var wrap = errBox.querySelector('.product-form__error-message-wrapper');
            if (msgEl) msgEl.textContent = (err && err.message) || 'Unable to add to cart';
            if (wrap) wrap.removeAttribute('hidden');
          }
        }
      });
    });
  }

  function bootstrap() {
    init();
    initSidePanel();
    initSizeGuideTabs();
    initHoverScroll();
    initStickyCta();
    initBuyNow();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootstrap);
  } else {
    bootstrap();
  }
})();
